import {
  TouchInput,
  CartFilled,
  ShoppingBag,
  DiscountTag,
} from "../../../../commons/components/Icons";
import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import "./modal-style.scss";

interface Props {
  landingSettings: any;
}

const HowToRedeemBtn: React.FC<Props> = ({ landingSettings }) => {
  const [openModal, toggleModal] = useState(false);
  const stepData = [
    {
      icon: <TouchInput />,
      title: "Step 1",
      subTitle: `Click on the button '${landingSettings.buttonText}'.`,
    },
    {
      icon: <CartFilled />,
      title: "Step 2",
      subTitle: "Select products you like and add them to cart.",
    },
    {
      icon: <ShoppingBag />,
      title: "Step 3",
      subTitle: "Proceed to checkout.",
    },
    {
      icon: <DiscountTag />,
      title: "Step 4",
      subTitle:
        "In the payments section, enter your Xoxo code and complete the purchase.",
    },
  ];
  const renderStep = (
    icon: any,
    title: string,
    subTitle: string,
    index: number
  ) => {
    return (
      <div className="d-flex">
        <div className="me-1">
          <div className="iconBackground">{icon}</div>
          {index !== 3 ? <div className="vertical" /> : null}
        </div>
        <div className="ms-2">
          <div className="title">{title}</div>
          <div className="subTitle">{subTitle}</div>
        </div>
      </div>
    );
  };
  return (
    <>
      <div
        className={`howToLink mt-3 ${
          !landingSettings.howToRedeem ? "d-none" : ""
        }`}
        onClick={() => toggleModal(!openModal)}
      >
        How to redeem?
      </div>
      {openModal ? (
        <Modal
          isOpen={openModal}
          toggle={() => toggleModal(!openModal)}
          className="howToRedeemInfo"
        >
          <ModalHeader
            className="modalTitle align-items-center border-bottom-0"
            toggle={() => toggleModal(!openModal)}
            charCode={<img src="/img/icons/closeIcon.svg" />}
          >
            How to redeem a Xoxo Code
          </ModalHeader>
          <ModalBody className="modalBody">
            <div>
              <div className="redemptionSteps">
                <div className="step">
                  <Row className="flex-column list">
                    {stepData.map((item, idx) => (
                      <Col>
                        {renderStep(item.icon, item.title, item.subTitle, idx)}
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
              <hr className="my-4" />
              <div className="notesSection">
                <div className="label mb-1">NOTE:</div>
                <div>
                  If your cart value is more than the value of your codes, you
                  can pay using Card/Netbanking. If your cart value is less than
                  the value of your codes, you can use the remaining value in
                  the next purchase until the Code expires.
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      ) : null}
    </>
  );
};

export default HowToRedeemBtn;
